module.exports = __webpack_public_path__ + "img/regen.139ecb95.png";